import IQueries from '@/interfaces/IQueries';

// Path with parameters
const horoscopeAnnuals: IQueries = {
    horoscopeTypesList: {
        path: '/astrology/horoscope_types',
        method: 'GET'
    }
};

export default horoscopeAnnuals;
